import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

const EXTRA = [["/employees", "Timeline"], ["/usage", "Usage Analytics"]];

export const moduleFor = (path, navGroups) => {
    const items = [...navGroups.flatMap((g) => g.items.map((i) => [i.to, i.label])), ...EXTRA];
    let best = null;
    for (const [to, label] of items) {
        if (!to) continue;
        const hit = to === "/" ? path === "/" : path === to || path.startsWith(`${to}/`);
        if (hit && (!best || to.length > best[0].length)) best = [to, label];
    }
    return best ? best[1] : "Other";
};

const send = (type, path, module) => api.post("/usage/track", { type, path, module }).catch(() => {});

// Logs a pageview per route change and a heartbeat every 60s while the tab is visible.
export const useUsageTracking = (path, module, enabled) => {
    const cur = useRef({ path, module });
    cur.current = { path, module };
    useEffect(() => { if (enabled) send("pageview", path, module); }, [path, module, enabled]);
    useEffect(() => {
        if (!enabled) return undefined;
        const t = setInterval(() => {
            if (document.visibilityState === "visible") send("heartbeat", cur.current.path, cur.current.module);
        }, 60000);
        return () => clearInterval(t);
    }, [enabled]);
};
